<div class="landing-page">

  <div class="welcome-banner">
    <div class="welcome-text">
      <h1>{{ greeting() }}@if (firstName()) {<span>, {{ firstName() }}</span>}!</h1>
      <p class="date">{{ currentDate }}</p>
    </div>
    <img class="welcome-logo" src="assets/pictures/gema-m.svg" alt="">
  </div>

  <div class="quick-grid">
    @for (tile of tiles(); track tile.dataCy) {
      @if (tile.disabled) {
        <div class="quick-card disabled" aria-disabled="true" [attr.data-cy]="tile.dataCy">
          <div [class]="'card-icon accent-' + tile.accent">
            <nb-icon pack="fas" [icon]="tile.icon"></nb-icon>
          </div>
          <div class="card-body">
            <span class="card-title">{{ tile.title }}</span>
            <span class="card-desc">{{ tile.description }}</span>
          </div>
        </div>
      } @else {
        <a class="quick-card" [routerLink]="tile.link" [queryParams]="tile.queryParams" [attr.data-cy]="tile.dataCy">
          <div [class]="'card-icon accent-' + tile.accent">
            <nb-icon pack="fas" [icon]="tile.icon"></nb-icon>
          </div>
          <div class="card-body">
            <span class="card-title">{{ tile.title }}</span>
            <span class="card-desc">{{ tile.description }}</span>
          </div>
        </a>
      }
    }
  </div>

</div>
